import React, { Fragment, useEffect, useState } from 'react'
import { Button, Divider, message } from 'antd'
import { useTranslation } from 'react-i18next'

import { useTour } from '../../../../../../../../components/Tour'
import api from '../../../../../../../../services/api'

const PageTypes = ({
  activeType: propActiveType,
  onClickType,
  pageStructureData,
  currentPage,
  pageTypes = {}
}) => {
  const [activeType, setActiveType] = useState()
  const { enableNext, currentStep } = useTour()
  const [loadingType, setLoadingType] = useState(null)
  const { t } = useTranslation()

  useEffect(() => {
    setActiveType(propActiveType)
  }, [propActiveType])

  const checkAiCreditStatus = async type => {
    setLoadingType(type)
    try {
      const serviceType = type === 'matchImage' ? 'image' : 'course'

      const response = await api.aiCredits.checkAiCreditsStatus(serviceType)
      if (response?.data?.allowed) {
        return true
      } else {
        message.error(t('aiusage:you_do_not_have_enough_ai_credits') + ' ' + type)
        return false
      }
    } catch (error) {
      message.error(t('aiusage:error_fetching_ai_credit_status'))
      return false
    } finally {
      setLoadingType(null)
    }
  }

  const handleClick = async type => {
    const isCurrentType = activeType === type
    const newType = isCurrentType ? null : type

    if (newType) {
      const isAllowed = await checkAiCreditStatus(newType)
      if (!isAllowed) return
    }

    const currentPageData = pageStructureData[currentPage - 1]

    const pageHasScenario =
      currentPageData &&
      currentPageData.data.some(node => node.type === 'SCENARIO')

    if (pageHasScenario) {
      message.error(t('v5:you_cannot_add_other_element_in_a_scenario_page'), 10)
      return
    }

    setActiveType(newType)

    if (onClickType) {
      onClickType(newType)
    }

    // Enable next step in tour if the clicked type matches the current tour step
    const tourTypeMapping = {
      'story': '[data-tour="story"]',
      'scenario': '[data-tour="scenario"]',
      'quiz': '[data-tour="quiz"]',
      'infographics': '[data-tour="infographics"]',
      'interactive': '[data-tour="interactive"]',
      'worldScenario': '[data-tour="worldScenario"]',
      'addContent': '[data-tour="addContent"]',
      'matchImage': '[data-tour="matchImage"]'
    }

    if (currentStep && tourTypeMapping[type] && currentStep.target === tourTypeMapping[type]) {
      enableNext()
    }
  }

  // Scroll to the target element when tour step is active
  useEffect(() => {
    if (currentStep && currentStep.target) {
      // Check if the target is a data-tour attribute within PageTypes
      const tourTypes = ['story', 'scenario', 'quiz', 'infographics', 'interactive', 'worldScenario', 'addContent', 'matchImage']
      const targetElement = tourTypes.find(type => currentStep.target === `[data-tour="${type}"]`)

      if (targetElement) {
        const element = document.querySelector(currentStep.target)
        if (element) {
          element.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest'
          })
        }
      }
    }
  }, [currentStep])

  useEffect(() => {
    if (activeType) {
      const notSelectable =
        activeType === 'bulletPoints' ||
        activeType === 'introduction' ||
        activeType === 'summary'

      if (notSelectable) return

      let type = activeType
      if (activeType === 'worldScenario') {
        type = 'Real World Scenario'
      }
      if (activeType === 'matchImage') {
        type = 'Match Image'
      }
      message.info(
        `${t('v5:pages_list_whose_content_you_want_to_reference')} ${type}.`
      )
    }
  }, [activeType])

  return (
    <Fragment>
      <div className="type-options">
        {Object.keys(pageTypes).map(type => (
          <Button
            loading={loadingType === type}
            key={type}
            className="type-option"
            type={activeType === type ? 'primary' : 'default'}
            onClick={() => handleClick(type)}
            data-tour={type}
          >
            {pageTypes[type]}
          </Button>
        ))}
      </div>
    </Fragment>
  )
}

export default PageTypes
